// apps/api/src/qxcircle/qxcircle-bookmark-list.ts
// Description: QXCircle saved posts list builder — keeps service under line cap.
// Owner: Masa Bayu
// Date: 2026-08-24

import type {
  QxCircleBookmarksResponse,
  QxCircleFeedPost,
} from "./qxcircle.types";

export function buildQxCircleBookmarksList(
  posts: QxCircleFeedPost[],
  hiddenPosts: Set<string>,
  blockedHandles: Set<string>,
  bookmarks: Set<string>,
  present: (post: QxCircleFeedPost) => QxCircleFeedPost,
): QxCircleBookmarksResponse {
  const items = posts
    .filter(
      (post) =>
        !hiddenPosts.has(post.id) &&
        !blockedHandles.has(post.authorHandle) &&
        bookmarks.has(post.id),
    )
    .map((post) => present(post))
    .sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt));
  return {
    world: "qxcircle",
    slice: "bookmark",
    items,
    count: items.length,
  };
}
